package ui


import api.data.DataProperty
import api.data.DataVisitSchedule
import api.data.request.DataUpdatedPropertyStatus
import api.repository.properties.ImplRepositoryProperties
import api.repository.visitScheduler.ImplRepositoryVisitScheduler
import api.service.properties.ImplServiceProperties
import api.service.visitScheduler.ImplServiceVisitScheduler
import dataAdminProfile
import dataProperties
import emotion.react.css
import js.objects.jso
import kotlinx.browser.window
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import kotlinx.css.data
import react.*
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.h3
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.label
import react.dom.html.ReactHTML.link
import react.dom.html.ReactHTML.option
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.select
import react.dom.html.ReactHTML.span
import react.router.dom.Link
import routes.EnumRoutes
import ui.components.DashboardIcon
import ui.components.DataSidebarMenu
import ui.components.InquiriesIcon
import ui.components.ListingsIcon
import ui.components.NavBar
import ui.components.OwnerSubmissionsIcon
import ui.components.ScheduleIcon
import web.cssom.ClassName
import web.cssom.string
import web.html.ButtonType
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

external interface PagePropertyListingProps : Props{
    var property: DataProperty
}

// Listing status enum
enum class ListingStatus(val status: String) {
    ACTIVE("Active"),
    PENDING("Pending"),
    REJECTED("Rejected"),
    ARCHIVED("Archived");

    override fun toString(): String = when(this) {
        ACTIVE -> "Active"
        PENDING -> "Pending"
        REJECTED -> "Reject"
        ARCHIVED -> "Archive"
    }
}

@OptIn(ExperimentalUuidApi::class)
val PagePropertyListing = FC<PagePropertyListingProps> { props->
    var dataProperty by useState(props.property)
    val (isSidebarOpen, setIsSidebarOpen) = useState(false)
    var listingStatus by useState(props.property.status.toString())
    var statusMessage by useState<String?>(null)
    val dataUpdateStatus = DataUpdatedPropertyStatus()
    val dataVisitSchedule = DataVisitSchedule()

    val scope = MainScope()

    var formData by useState(FormData())

    val handleSaveStatus = {
        // In a real app this would call an API to persist the status change
        scope.launch {
            dataUpdateStatus.status = listingStatus
            dataUpdateStatus.id = dataProperty.id.toString()
            if (listingStatus == ListingStatus.ACTIVE.status){
                dataUpdateStatus.approvedBy = "${dataAdminProfile.firstName} ${dataAdminProfile.lastName}"
                dataUpdateStatus.isApproved = true
            }
            if (listingStatus == ListingStatus.REJECTED.status){
                dataUpdateStatus.rejectedBy = "${dataAdminProfile.firstName} ${dataAdminProfile.lastName}"
                dataUpdateStatus.isApproved = false
            }
            if (listingStatus == ListingStatus.ARCHIVED.status){
                dataUpdateStatus.archivedBy = "${dataAdminProfile.firstName} ${dataAdminProfile.lastName}"
                dataUpdateStatus.isApproved = false
            }
            if (listingStatus == ListingStatus.PENDING.status){
                dataUpdateStatus.pendingBy = "${dataAdminProfile.firstName} ${dataAdminProfile.lastName}"
                dataUpdateStatus.isApproved = false
            }

            if (updatePropertyStatus(dataUpdateStatus)){
                statusMessage = "Listing status updated to $listingStatus"
                window.setTimeout({
                    statusMessage = null
                }, 3000)
            } else{
                statusMessage = "Listing status update failed"
                window.setTimeout({
                    statusMessage = null
                }, 3000)
            }

        }

    }

    val handleScheduleVisit = {
        console.log("Scheduling visit:", formData)
        formData = FormData()
        dataVisitSchedule.id = Uuid.random().toString()
        dataVisitSchedule.propertyId = dataProperty.id
        dataVisitSchedule.visitOn = formData.dateTime
        dataVisitSchedule.name = formData.visitorName
        dataVisitSchedule.propertyLocation = dataProperty.location
        dataVisitSchedule.email = formData.email
        dataVisitSchedule.phone = formData.phone
        scope.launch {
            val visitScheduled = scheduleVisit(dataVisitSchedule)
            if (visitScheduled){
                window.alert("Visit scheduled")
            } else{
                window.alert("Visit schedule failed")
            }
        }

    }

    div {
        className = ClassName("min-h-screen bg-white flex relative")


//        Side Navigation
        NavBar{
            this.activeNavItem = "Properties"
        }

        // Main Content
        div {
            className = ClassName("flex-1 p-4 lg:p-8 xl:px-48 ml-0 lg:ml-0")


            // Page Title
            div {
                className = ClassName("text-center mb-6")
                h1 {
                    className = ClassName("text-xl lg:text-2xl font-normal text-boon-primary")
                    +"Property Overview"
                }
            }

            // Property Overview Section
            div {
                className = ClassName("flex flex-col lg:flex-row gap-4 mb-8")

                // Property Image
                div {
                    className = ClassName("lg:w-64")
                    img {
                        src = dataProperty.images?.get(0).toString()
                        alt = dataProperty.title
                        className = ClassName("w-full h-44 object-cover rounded-lg")
                    }
                }

                // Property Info Card
                div {
                    className = ClassName("flex-1 bg-boon-bg-pink rounded-xl p-5 relative")
                    div {
                        className = ClassName("absolute top-5 left-5")
                        div {
                            className = ClassName("w-8 h-8 bg-boon-bg-pink-light rounded-full")
                        }
                    }
                    div {
                        className = ClassName("absolute top-[33px] left-[23px] text-boon-primary")
//                        HomeIcon
                    }
                    div {
                        className = ClassName("mt-12")
                        h3 {
                            className = ClassName("text-lg font-normal text-black mb-2")
                            +dataProperty.title
                        }
                        div {
                            className = ClassName("text-sm font-normal text-black mb-1")
                            style = jso {
                                fontFamily = string("Century Schoolbook, serif")
                            }
                            +dataProperty.location
                        }
                        div {
                            className = ClassName("text-sm font-normal text-black mb-4")
                            style = jso {
                                fontFamily = string("Century Schoolbook, serif")
                            }
                            +"${dataProperty.bedrooms} | ${dataProperty.bathrooms} | ${dataProperty.size}"
                        }
                        div {
                            className = ClassName("flex flex-col sm:flex-row gap-3")
                            button {
                                className = ClassName("bg-boon-primary text-white px-4 py-3 rounded-xl text-sm font-normal flex-shrink-0")
                                style = jso {
                                    fontFamily = string("Century Schoolbook, serif")
                                }
                                +"Edit Property"
                                onClick = {
                                    window.location.href = "${EnumRoutes.EditProperty.routeID}?id=${dataProperty.id}"
                                }
                            }
                            button {
                                className = ClassName("bg-boon-bg-pink-light text-boon-primary px-4 py-3 rounded-xl text-sm font-normal flex-1")
                                style = jso {
                                    fontFamily = string("Century Schoolbook, serif")
                                }
                                +"Contact Owner"
                            }
                        }
                    }
                    // Listing Status
                    div {
                        className = ClassName("mt-4")

                        label {
                            className = ClassName("text-sm font-normal mb-2 block")
                            +"Status"
                        }

                        div {
                            className = ClassName("flex items-center gap-2")

                            // Status buttons
                            ListingStatus.entries.toTypedArray().forEach { status ->
                                button {
                                    key = status.status
                                    onClick = { listingStatus = status.status}
                                    val isActive = listingStatus == status.status
                                    val baseClasses = "px-3 py-2 rounded-full text-sm font-normal border transition-all"
                                    val activeClasses = when (listingStatus) {
                                        ListingStatus.ACTIVE.status -> "bg-green-600 text-white border-green-600"
                                        ListingStatus.PENDING.status -> "bg-amber-500 text-white border-amber-500"
                                        ListingStatus.ARCHIVED.status -> "bg-gray-500 text-white border-gray-500"
                                        ListingStatus.REJECTED.status -> "bg-red-600 text-white border-amber-500"
                                        else -> {
                                            return@button
                                        }
                                    }
                                    val inactiveClasses = "bg-[#F8F8F7] text-black border-transparent"

                                    className =
                                        ClassName("$baseClasses ${if (isActive) activeClasses else inactiveClasses}")
                                    asDynamic()["aria-pressed"] = isActive

                                    +status.toString()
                                }
                            }

                            button {
                                onClick = { handleSaveStatus() }
                                className =
                                    ClassName("ml-4 bg-boon-primary text-white px-4 py-2 rounded-xl text-sm font-normal")
                                style = jso {
                                    fontFamily = string("Century Schoolbook, serif")
                                }
                                +"Update Status"
                            }
                        }

                        statusMessage?.let { message ->
                            div {
                                className = ClassName("mt-2 text-sm text-green-700")
                                +message
                            }
                        }
                    }
                }
            }

            // Description Section
            div {
                className = ClassName("text-center mb-6")
                h2 {
                    className = ClassName("text-xl lg:text-2xl font-normal text-black mb-4")
                    +"Description"
                }
                p {
                    className = ClassName("text-sm font-normal text-black max-w-2xl mx-auto")
                    style = jso {
                        fontFamily = string("Century Schoolbook, serif")
                    }
                    +dataProperty.description
                }
            }

            // Gallery Section
            div {
                className = ClassName("text-center mb-6")
                h2 {
                    className = ClassName("text-xl lg:text-2xl font-normal text-black mb-4")
                    +"Gallery"
                }
                div {
                    className = ClassName("flex flex-row gap-4 mb-8 overflow-x-auto whitespace-nowrap")
                    ImageGallery {
                        images = dataProperty.images ?: emptyList()
                    }
//                    dataProperty.images?.forEach {
//                        img {
//                            src = it
//                            alt = dataProperty.title
//                            className = ClassName("inline-block h-36 object-cover rounded-xl flex-shrink-0")
//                        }
//                    }
                }
            }

            // Key Details Section
            div {
                className = ClassName("text-center mb-6")
                h2 {
                    className = ClassName("text-xl lg:text-2xl font-normal text-black mb-4")
                    +"Key Details"
                }
                div {
                    className = ClassName("flex flex-col sm:flex-row gap-4 mb-8")
                    div {
                        className = ClassName("flex-1 text-center")
                        div {
                            className = ClassName("text-sm font-normal text-black")
                            style = jso {
                                fontFamily = string("Century Schoolbook, serif")
                            }
                            +"Location: ${dataProperty.location}"
                        }
                    }
                    div {
                        className = ClassName("flex-1 text-center")
                        div {
                            className = ClassName("text-sm font-normal text-black")
                            style = jso {
                                fontFamily = string("Century Schoolbook, serif")
                            }
                            +"Bedrooms: ${dataProperty.bedrooms.toString()}"
                        }
                    }
                    div {
                        className = ClassName("flex-1 text-center")
                        div {
                            className = ClassName("text-sm font-normal text-black")
                            style = jso {
                                fontFamily = string("Century Schoolbook, serif")
                            }
                            +"Bathrooms: ${dataProperty.bathrooms.toString()}"
                        }
                    }
                    div {
                        className = ClassName("flex-1 text-center")
                        div {
                            className = ClassName("text-sm font-normal text-black")
                            style = jso {
                                fontFamily = string("Century Schoolbook, serif")
                            }
                            + "Size: ${dataProperty.size.toString()}"
                        }
                    }
                }
            }

            // Schedule New Visit Form
            div {
//        className = ClassName("")
                className = ClassName("bg-boon-light-pink flex overflow-hidden flex-col px-20 w-full")

                // Schedule New Visit Title
                div {
                    css(ClassName("text-center mb-6")){

                    }

                    h3 {
                        className = ClassName("text-lg font-normal text-black")
                        +"Schedule New Visit"
                    }
                }

                // Schedule New Visit Form
                div{
                    div {
                        className = ClassName("flex flex overflow-hidden flex-col px-20 w-full")

                        // Visitor Name
                        div {
                            className = ClassName("space-y-1 mb-6")
                            label {
                                className = ClassName("text-sm font-normal text-black")
                                +"Visitor Name"
                            }
                            input {
                                type = web.html.InputType.text
                                placeholder = "Enter visitor name"
                                value = formData.visitorName
                                onChange = { e ->
                                    val target = e.target.asDynamic()
                                    formData = formData.copy(visitorName = target.value as String)
                                }
                                className =
                                    ClassName("w-full px-3 py-2 rounded-xl bg-white  text-sm border-none outline-none text-boon-gray")
                                style = jso {
                                    fontFamily = string("Century Schoolbook, serif")
                                }
                            }
                        }

                        // Property
                        div {
                            className = ClassName("space-y-1 mb-6")
                            label {
                                className = ClassName("text-sm font-normal text-black")
                                +"Property"
                            }

                            select {
                                value = formData.property
                                onChange = { e ->
                                    val target = e.target.asDynamic()
                                    formData = formData.copy(property = target.value as String)
                                }
                                className =
                                    ClassName("w-full px-3 py-2 rounded-xl bg-white  text-sm border-none outline-none text-boon-gray")
                                style = jso {
                                    fontFamily = string("Century Schoolbook, serif")
                                }

                                option {
                                    value = dataProperty.title
                                    +dataProperty.title
                                }
                            }
                        }

                        // Email
                        div {
                            className = ClassName("space-y-1 mb-6")
                            label {
                                className = ClassName("text-sm font-normal text-black")
                                +"Email"
                            }

                            input {
                                type = web.html.InputType.email
                                placeholder = "Enter email address"
                                value = formData.email
                                onChange = { e ->
                                    val target = e.target.asDynamic()
                                    formData = formData.copy(email = target.value as String)
                                }
                                className =
                                    ClassName("w-full px-3 py-2 rounded-xl bg-white text-sm border-none outline-none text-boon-gray")
                                style = jso {
                                    fontFamily = string("Century Schoolbook, serif")
                                }
                            }
                        }
                        // Phone
                        div {
                            className = ClassName("space-y-1 mb-6")
                            label {
                                className = ClassName("text-sm font-normal")
                                +"Phone Number"
                            }
                            input {
                                id = "phone"
                                value = formData.phone
                                onChange = { e ->
                                    val target = e.target.asDynamic()
                                    formData = formData.copy(phone = target.value as String)
                                }
                                type = web.html.InputType.tel
                                required = true
                                placeholder = "Enter Your Phone Number"
                                className =
                                    ClassName("w-full bg-white rounded-lg px-4 py-3 text-sm text-[#949494] font-['Century_Schoolbook'] outline-none")
                            }
                        }


                        // Date & Time
                        div {
                            className = ClassName("flex-1")
                            label {
                                className = ClassName("text-sm font-normal text-black")
                                +"Date & time"
                            }

                            input {
                                type = web.html.InputType.datetimeLocal
                                placeholder = "Pick date & time"
                                value = formData.dateTime
                                onChange = { e ->
                                    val target = e.target.asDynamic()
                                    formData = formData.copy(dateTime = target.value as String)
                                    console.log(formData.dateTime)
                                }
                                className =
                                    ClassName("w-full px-3 py-2 rounded-xl bg-white rounded-xl text-sm border-none outline-none text-boon-gray")
                                style = jso {
                                    fontFamily = string("Century Schoolbook, serif")
                                }
                            }
                        }
                    }
                    // Schedule Visit Button
                    div {
                        className = ClassName("flex justify-center px-4 py-4")
                        button {
                            onClick = { handleScheduleVisit() }
                            className = ClassName("bg-[#7F161B] text-[#FFF4F4] rounded-lg px-4 py-3 text-sm font-['Century_Schoolbook']")
                            style = jso {
                                fontFamily = string("Century Schoolbook, serif")
                            }
                            +"Schedule Visit"
                        }
                    }
                }

            }

        }
    }
}


val ImageGallery = FC<ImagesProps> { props ->
    var selectedIndex by useState<Int?>(null)
    var images by useState(props.images.toMutableList())
    val totalImages = props.images.size

    fun showNext() {
        selectedIndex = if (selectedIndex != null) (selectedIndex!! + 1) % totalImages else 0
    }

    fun showPrev() {
        selectedIndex = if (selectedIndex != null) (selectedIndex!! - 1 + totalImages) % totalImages else totalImages - 1
    }

    // Horizontal scrollable gallery
    div {
        className = ClassName("flex flex-row gap-4 overflow-x-auto whitespace-nowrap mb-8")
        props.images.forEachIndexed { index, image ->
            img {
                src = image
                alt = "Image $index"
                className = ClassName("inline-block h-36 object-cover rounded-xl flex-shrink-0 cursor-pointer")
                onClick = { selectedIndex = index }
            }
        }
    }

    // Popup modal with buttons
    if (selectedIndex != null) {
        div {
            className = ClassName("fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50")

            // Close on background click
            onClick = { selectedIndex = null }

            // Previous button
            button {
                type = ButtonType.button

                className = ClassName(
                    "absolute left-4 top-1/2 transform -translate-y-1/2 bg-white text-black rounded-full w-10 h-10 flex items-center justify-center"
                )
                +"‹"
                onClick = {

                    it.stopPropagation() // Prevent closing modal
                    showPrev()
                }
            }

            // Next button
            button {
                type = ButtonType.button
                className = ClassName(
                    "absolute right-4 top-1/2 transform -translate-y-1/2 bg-white text-black rounded-full w-10 h-10 flex items-center justify-center"
                )
                +"›"
                onClick = {
                    it.stopPropagation() // Prevent closing modal
                    showNext()
                }
            }

            // Display selected image
            img {
                src = props.images[selectedIndex!!]
                alt = "Selected Image"
                className = ClassName("max-h-[90%] max-w-[90%] rounded-lg")
            }

            // Close button
            button {
                type = ButtonType.button
                className = ClassName("absolute top-4 right-4 text-white text-2xl font-bold")
                +"×"
                onClick = { selectedIndex = null }
            }
        }
    }
}
external interface ImagesProps : Props {
    var images: List<String>
}

suspend fun updatePropertyStatus(dataUpdateStatus: DataUpdatedPropertyStatus): Boolean{
    val implUpdateStatus = ImplRepositoryProperties(ImplServiceProperties).updatePropertyStatus(dataUpdateStatus)
    return implUpdateStatus
}

suspend fun scheduleVisit(schedule: DataVisitSchedule): Boolean{
    val implScheduleVisit = ImplRepositoryVisitScheduler(ImplServiceVisitScheduler()).createVisitSchedule(schedule)
   return implScheduleVisit
}